import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getRequestToken, getAccessToken } from '../actions';
import LoginWithMotorsportRegButton from '../components/LoginForm/LoginWithMotorsportRegButton';
import hasStorage from '../store/hasStorage';

class Login extends Component {

  componentDidMount() {
    const {location, user, getAccessToken} = this.props;
    const {oauth_verifier, oauth_token} = location.query;

    if (oauth_verifier && (oauth_token === user.oauthToken)) {
      getAccessToken(oauth_verifier);
    }
  }

  render() {
    const {getRequestToken} = this.props;

    const isStorageEnabled = hasStorage('localStorage');

    return (
      <div className="container">
        {!isStorageEnabled &&
          <div>
            <div className="alert alert-form-error">Your browser is refusing cookies which you need to log in. Please follow these directions to <a href="https://support.motorsportreg.com/how-to-enable-cookies-and-local-storage-in-web-browsers">enable cookies and local storage</a></div>
            <hr />
          </div>
        }
        <LoginWithMotorsportRegButton getRequestToken={getRequestToken} />
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    user: state.user,
  }
);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ getRequestToken, getAccessToken }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login.js